export default __webpack_public_path__ + "static/media/new-report.16025437.svg";